import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=77fed514"
import script from "./Manage.vue?vue&type=script&lang=ts"
export * from "./Manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports